import { useQuery } from '@tanstack/react-query';
import { KeyQueryApi } from '../config/apiConfig';
 
import { postApi } from '../services/api/postApi';
import { POST_TYPES } from '../types/common.type';
import { useLanguage } from './useLanguage';

/**
 * Hook for fetching post data of different types (movies, games, comics, novels)
 * @param type Post type (from POST_TYPES enum)
 * @returns Object with query functions for different operations
 */
 

// Get post details by ID
export const usePostDetails = (slug: string, type: string = POST_TYPES.MOVIES) => {
  const { getCurrentLanguage } = useLanguage();
  const language = getCurrentLanguage();
  return useQuery({
    queryKey: [KeyQueryApi.POST_DETAIL, slug, type, language],
    queryFn: async () => {
      try {
        return await postApi.fetchPostDetailsBySlug(slug, type);
      } catch (error: any) {
        if (error.message === 'Not Found') {
          console.error('Post not found');
          // Optionally, handle navigation to a "Not Found" page here
        }
        throw error;
      }
    },
    enabled: !!slug,
    staleTime: 5 * 60 * 1000, // 5 minutes
  });
};

// Get posts by category
export const usePostsByCategory = (category: string, type: string = POST_TYPES.MOVIES) => {
  const { getCurrentLanguage } = useLanguage();
  const language = getCurrentLanguage();
  return useQuery({
    queryKey: [KeyQueryApi.GET_LIST_POST, 'category', category, type, language],
    queryFn: () => postApi.fetchPostsByCategory(category, type, language),
    enabled: !!category,
    staleTime: 5 * 60 * 1000, // 5 minutes
  });
};

// Get latest posts
export const useLatestPosts = (type: string = POST_TYPES.MOVIES) => {
  const { getCurrentLanguage } = useLanguage();
  const language = getCurrentLanguage();
  return useQuery({
    queryKey: [KeyQueryApi.GET_LIST_POST, 'latest', type, language],
    queryFn: () => postApi.fetchLatestPosts(type, language),
    staleTime: 5 * 60 * 1000, // 5 minutes
  });
};

// Search posts
export const useSearchPosts = (query: string, type: string = POST_TYPES.MOVIES) => {
  const { getCurrentLanguage } = useLanguage();
  const language = getCurrentLanguage();
  return useQuery({
    queryKey: [KeyQueryApi.DASHBOARD_SEARCH, query, type, language],
    queryFn: () => postApi.searchPosts(query, type, language),
    enabled: !!query && query.length > 2,
    staleTime: 5 * 60 * 1000, // 5 minutes
  });
};
